import { render } from "./DxtPackageTopUp.vue?vue&type=template&id=2ef7a7b1&scoped=true"
import script from "./DxtPackageTopUp.vue?vue&type=script&lang=js"
export * from "./DxtPackageTopUp.vue?vue&type=script&lang=js"

import "./DxtPackageTopUp.vue?vue&type=style&index=0&id=2ef7a7b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ef7a7b1"

export default script